export default {
  "varchar": 'xmHidden',
  readOnly: 'readOnly',
  Input: 'xmInput',
  'HtmlEditor': 'xmEditor',
  'Radio.Group': 'xmRadioGroup',
  Radio: 'xmRadioGroup',
  'Rate': 'xmRate',
  'Switch': 'xmSwitch',
  'IconSelect': 'xmIconSelect',
  'Checkbox.Group': 'xmCheckBoxGroup',
  'Cascader': 'xmCascader',
  'Input.Password': 'xmPassword',
  'PriceInput': 'xmPrice',
  TreeSelect: 'xmTree',
  'Select': 'xmSelect',
  'TimePicker': 'xmTimePicker',
  'DatePicker__month': 'xmMonthSel',
  'DatePicker__year': 'xmYearSel',
  'DatePicker.RangePicker__month': 'xmMonthRange',
  'DatePicker.RangePicker__year': 'xmYearRange',
  'Input.TextArea': 'xmTextArea',
  DatePicker: 'xmDateSel',
  'DatePicker__withTime': 'xmDateSel',
  'CheckEdit':'xmCheckBox',
}
